import React, { useState } from "react";
import { isProjectOngoing } from "../../_helpers";
import { Card, CardActionArea, CardContent, CardMedia, makeStyles, Tooltip } from "@material-ui/core";
import { GalleryViewer } from "..";
import { useNavigate } from "react-router-dom";
import Edit from "@material-ui/icons/Edit";

const useStyles = makeStyles({
    root: {
        margin: '20px 20px 0 0',
        width: '100%',
        maxWidth: 376,
        float: 'left',
    },
    media: {
        height: 240,
    },
});

export function PortfolioCard({ app, isAuthorized = false, editApp }) {
    const navigate = useNavigate();
    const classes = useStyles();

    const [openGalleryViewer, setOpenGalleryViewer] = useState({});
    const handleGalleryViewer = (key, state) => {
        setOpenGalleryViewer(Object.assign({ ...openGalleryViewer, [key]: state }));
    };

    return (
        <Card className={classes.root} style={{ position: 'relative' }}>
            <CardActionArea onClick={() => navigate('/apps/' + app?.slug)} >
                <CardMedia
                    className={classes.media}
                    image={app?.image}
                    alt={app?.title}
                />
                <CardContent style={{ minHeight: '148px' }}>
                    <h5 style={{ fontFamily: 'roboto', fontWeight: 'bolder', fontSize: '18px', marginBottom: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{app?.title}</h5>
                    <p style={{ lineHeight: '1.2', marginBottom: '10px', textAlign: 'justify', fontSize: '14px' }}>{app?.excerpt}</p>
                </CardContent>
            </CardActionArea>
            <div className="app-meta">
                <div className="info-tags">
                    {isProjectOngoing(app?.complete_date) && <span>Ongoing</span>}
                    {isAuthorized && (app?.hidden === 1) && <span>Hidden</span>}
                </div>
                {(app?.screenshots?.length > 0) && <Tooltip title="App Screenshots"><a href="/apps" onClick={(e) => { e.preventDefault(); handleGalleryViewer(app?.hex, true); }}><i className="icon-image2"></i></a></Tooltip>}
                {(app?.screenshots?.length > 0) && <GalleryViewer
                    images={app?.screenshots}
                    open={openGalleryViewer[app?.hex]}
                    closed={(v) => handleGalleryViewer(app?.hex, v)}
                />}
                {(app?.url !== '') && <Tooltip title="App URL"><a href={app?.url} target="_blank" rel="noreferrer"><i className="icon-link2"></i></a></Tooltip>}
                {(app?.repo_url !== '') && <Tooltip title="App Repository"><a href={app?.repo_url} target="_blank" rel="noreferrer"><i className="icon-github"></i></a></Tooltip>}
                {(app?.design_url !== '') && <Tooltip title="App Designs"><a href={app?.design_url} target="_blank" rel="noreferrer"><i className="icon-dribbble2"></i></a></Tooltip>}
            </div>
            {(app?.technologies.length > 0) && <div className="tech-tags">
                {(app?.technologies).map((tech, j) => {
                    return <span key={j}>{tech}</span>
                })}
            </div>}
            {isAuthorized && <div className="edit-opt">
                <div className="edit-btn" onClick={() => editApp(app)} ><Edit /></div>
            </div>}
        </Card>
    );
}